import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_OPT_SITE_TRACKER,
	TOGGLE_OPT_SITE_DIALOG,
	GET_OPT_SITE_TRACKER_DETAILS,
	GET_OPT_SITE_TRACKER_DROPDOWNS,
	TOGGLE_DELETE_OPT_SITE_DIALOG,
	GET_OPT_SITE_AUTOCOMPLETE,
	GET_DRIVETESTS_CITIES,
	GET_DRIVETESTS_DRIVES,
	GET_DRIVETESTS_DATES,
	SET_SELECTED_DATES,
	GET_FAILURES,
	SET_SELECTED_FAILURES,
	TOGGLE_ATTACH_FILE_OPT_SITE_DIALOG,
	TOGGLE_REMOVE_FILE_OPT_SITE_DIALOG
} from '../actions/OptSiteActions';

const initialState = {
	incidents: [],
	optSiteDialogVisibility: false,
	incidentDetails: [],
	dropdowns: [],
	optimizationsSiteDto: [],
	tableId: '',
	deleteOptSiteDialogVisibility: false,
	attachFileOptSiteDialogVisibility: false,
	removeFileOptSiteDialogVisibility: false,
	autocompleteFields: [],
	cities: [],
	drives: [],
	dates: [],
	selectedDates: [],
	failures: [],
	selectedFailures: [],
	formState: {
		values: {
			inputFilePath: '',
			stream: 'Postcode Analysis',
			globalStatus: 'Open'
		},
		isValid: false,
		touched: {},
		errors: {},
	},
};

const optSiteReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							drives: [],
							dates: [],
						};
					}
					case GET_OPT_SITE_TRACKER: {
						return {
							...state,
							incidents: action.incidents
						};
					}
					case TOGGLE_OPT_SITE_DIALOG: {
						return {
							...state,
							optSiteDialogVisibility: action.visible,
							tableId: action.tableId,
							formState: initialState.formState
						};
					}
					case GET_OPT_SITE_TRACKER_DETAILS: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.incidentDetails }
							}
						};
					}
					case GET_OPT_SITE_TRACKER_DROPDOWNS: {
						return {
							...state,
							dropdowns: action.dropdowns
						};
					}
					case TOGGLE_DELETE_OPT_SITE_DIALOG: {
						return {
							...state,
							deleteOptSiteDialogVisibility: action.visible,
							tableId: action.tableId,
						};
					}
					case GET_OPT_SITE_AUTOCOMPLETE: {
						return {
							...state,
							autocompleteFields: action.autocompleteFields,
						};
					}
					case GET_DRIVETESTS_CITIES: {
						return {
							...state,
							cities: action.cities
						};
					}
					case GET_DRIVETESTS_DRIVES: {
						return {
							...state,
							drives: action.drives
						};
					}
					case GET_DRIVETESTS_DATES: {
						return {
							...state,
							dates: action.dates
						};
					}
					case SET_SELECTED_DATES: {
						return {
							...state,
							selectedDates: action.selectedDates
						};
					}
					case GET_FAILURES: {
						return {
							...state,
							failures: action.failures
						};
					}
					case SET_SELECTED_FAILURES: {
						return {
							...state,
							selectedFailures: action.selectedFailures
						};
					}
					case TOGGLE_ATTACH_FILE_OPT_SITE_DIALOG: {
						return {
							...state,
							attachFileOptSiteDialogVisibility: action.visible,
						};
					}
					case TOGGLE_REMOVE_FILE_OPT_SITE_DIALOG: {
						return {
							...state,
							removeFileOptSiteDialogVisibility: action.visible,
						};
					}
					default: {
						return state;
					}
	}
};

export default optSiteReducer;
